'use client'

import { Popover, PopoverContent, PopoverTrigger } from "../shadcn/popover"
import { Button } from "../shadcn/button"
import { ChevronDownIcon } from "lucide-react"
import { useEffect, useState } from "react"
import { Command, CommandGroup, CommandItem, CommandList } from "../shadcn/command"
import { Input } from "../shadcn/input"

export type ListFilterPriceProps = {
    placeholder: string
    action?: (value: string) => void
}

export default function ListFilterPrice({ placeholder, action }: ListFilterPriceProps) {
    const [open, setOpen] = useState(false)
    const [minimumValue, setMinimumValue] = useState<string | null>(null)
    const [maximumValue, setMaximumValue] = useState<string | null>(null)
    const [draftMinimumValue, setDraftMinimumValue] = useState<string>("")
    const [draftMaximumValue, setDraftMaximumValue] = useState<string>("")

    useEffect(() => {
        if (open) {
            setDraftMinimumValue(minimumValue ?? "")
            setDraftMaximumValue(maximumValue ?? "")
        }
    }, [open])

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <Button
                    variant={minimumValue == null && maximumValue == null ? "outline" : "defaultLight"}
                    role="combobox"
                    size="lg"
                    aria-expanded={open}
                    className="justify-between"
                >
                    {placeholder}
                    <ChevronDownIcon className="opacity-50" />
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-[260px] p-0">
                <Command>
                    <CommandList>
                        <CommandGroup>
                            <CommandItem className="flex items-center gap-3">
                                <span className="text-sm">Minimum</span>
                                <div className="ml-auto w-28">
                                    <Input
                                        type="text"
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        placeholder="0"
                                        value={draftMinimumValue}
                                        onChange={(e) => {
                                            const digits = e.target.value.replace(/\D/g, '')
                                            setDraftMinimumValue(digits)
                                        }}
                                    />
                                </div>
                            </CommandItem>
                            <CommandItem className="flex items-center gap-3">
                                <span className="text-sm">Maximum</span>
                                <div className="ml-auto w-28">
                                    <Input
                                        type="text"
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        placeholder="∞"
                                        value={draftMaximumValue}
                                        onChange={(e) => {
                                            const digits = e.target.value.replace(/\D/g, '')
                                            setDraftMaximumValue(digits)
                                        }}
                                    />
                                </div>
                            </CommandItem>
                            <div className="p-3 pt-2 w-full">
                                <Button
                                    className="w-full"
                                    onClick={() => {
                                        const nextMin = draftMinimumValue.length ? draftMinimumValue : null
                                        const nextMax = draftMaximumValue.length ? draftMaximumValue : null
                                        setMinimumValue(nextMin)
                                        setMaximumValue(nextMax)
                                        if (action) {
                                            action(`${nextMin ?? ''}-${nextMax ?? ''}`)
                                        }
                                        setOpen(false)
                                    }}
                                >
                                    Appliquer
                                </Button>
                                <Button
                                    variant="outline"
                                    className="w-full mt-2"
                                    onClick={() => {
                                        setDraftMinimumValue("")
                                        setDraftMaximumValue("")
                                        setMinimumValue(null)
                                        setMaximumValue(null)
                                        if (action) {
                                            action("")
                                        }
                                    }}
                                >
                                    Réinitialiser
                                </Button>
                            </div>
                        </CommandGroup>
                    </CommandList>
                </Command>
            </PopoverContent>
        </Popover>
    )
}